import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IPurchaseInvoiceReportGetAllParams } from "@api/stores/purchaseInvoiceReport/types";

import type { IPathBaseParam } from "./path";
import type { IPurchaseInvoiceReportStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IPurchaseInvoiceReportStatsResponse>,
  IPathBaseParam,
  IPurchaseInvoiceReportGetAllParams
>("stores.purchaseInvoiceReport.stats");

export const stats = {
  ...getApis,
};
